module.exports = __webpack_public_path__ + "static/media/valueProposition.f35b1e1d.svg";